export const EL_ID_PORTAL_MAIN_AFTER = "portal-main-after";
